"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8937],{

/***/ 70655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8 5v14l11-7z"
}), 'PlayArrow');

/***/ }),

/***/ 53685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useStatistics; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/statistics.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StatisticsStatic;

(function (StatisticsStatic) {
  StatisticsStatic["statistics"] = "/v2/statistics";
})(StatisticsStatic || (StatisticsStatic = {}));

var StatisticsDynamic = {// /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get Statistics details
  //  */
  // StatisticsDetail: (StatisticsID?: number) =>
  //   `-${StatisticsID}`,
};
var StatisticsEndpoints = _objectSpread(_objectSpread({}, StatisticsDynamic), StatisticsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/statistics-services.request.ts


var getStatistics = function getStatistics(filters) {
  return (0,base_services_request/* getRequest */.A_)(StatisticsEndpoints.statistics, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
;// CONCATENATED MODULE: ./custom-hooks/use-statistics.hook.ts


function useStatistics(filters) {
  return (0,useQuery/* useQuery */.a)(["statistics", filters], function () {
    return getStatistics(filters);
  }, {
    cacheTime: 5 * 60 * 1000,
    // 5 minutos
    staleTime: 2 * 60 * 1000 // 2 minutos

  });
}

/***/ }),

/***/ 89139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66621);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function JoinRemax() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_3__.useTranslations)("join");
  var translationJoinUs = (0,next_intl__WEBPACK_IMPORTED_MODULE_3__.useTranslations)("join.joinUs");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(BackgroundImage, null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverDetails, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverContainer, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverTitle, null, translation("title")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverText, null, translationJoinUs("description")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverText, null, translationJoinUs("control")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CoverButton, {
    component: "a",
    href: "https://reclutamiento.remaxrd.com/#Formulario",
    target: "_blank",
    rel: "noopener noreferrer"
  }, translationJoinUs("joinFamily"))))));
}

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "eha9ccs8"
} : 0)( true ? {
  name: "n48rgu",
  styles: "width:100%;position:relative"
} : 0);

var BackgroundImage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eha9ccs7"
} : 0)( true ? {
  name: "u25v7",
  styles: "width:100%;height:100dvh;background-image:url(\"/images/v2/pic/image-04.webp\");background-size:cover;background-position:center 25%;background-repeat:no-repeat;background-color:var(--color-brand-bg-secondary);@media screen and (max-width: 991px){height:50dvh;}@media screen and (max-width: 500px){height:250px;background-size:cover;background-position:center center;background-repeat:no-repeat;}"
} : 0);

var Image = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("img",  true ? {
  target: "eha9ccs6"
} : 0)( true ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : 0);

var CoverDetails = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eha9ccs5"
} : 0)( true ? {
  name: "y234pn",
  styles: "width:100%;height:100%;position:absolute;top:0;@media screen and (max-width: 991px){position:static;background-color:var(--color-brand-blue-main);}"
} : 0);

var CoverContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eha9ccs4"
} : 0)( true ? {
  name: "1st9kbp",
  styles: "height:100%;position:relative"
} : 0);

var CoverContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eha9ccs3"
} : 0)( true ? {
  name: "qu0lif",
  styles: "position:absolute;left:5dvw;top:20dvh;width:563px;padding:44px 57px 50px;background-color:var(--color-brand-blue-main);border-radius:15px;@media screen and (max-width: 991px){position:static;width:100%;}@media screen and (max-width: 767px){padding:40px 20px;*{text-align:center;}}"
} : 0);

var CoverTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h1",  true ? {
  target: "eha9ccs2"
} : 0)( true ? {
  name: "y7t7wt",
  styles: "font-size:1.938rem;font-weight:500;color:#fff;margin-bottom:33px;@media screen and (max-width: 480px){font-size:1.638rem;}"
} : 0);

var CoverText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "eha9ccs1"
} : 0)( true ? {
  name: "1mzfxys",
  styles: "color:#fff;font-size:15.6px;font-weight:400;margin-bottom:20px;line-height:29px"
} : 0);

var CoverButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "eha9ccs0"
} : 0)( true ? {
  name: "1u0x4t6",
  styles: "width:100%;max-width:265px;position:absolute;bottom:-20px;margin:0 auto;left:50%;transform:translateX(-50%);text-decoration:none;background-color:var(--color-brand-red-main);border-radius:15px!important"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (JoinRemax);

/***/ }),

/***/ 82273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ unete_Motivation; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PlayArrow.js
var PlayArrow = __webpack_require__(70655);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./shared/components/slide-transition/index.tsx
var slide_transition = __webpack_require__(97472);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/video-modal/index.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function VideoModal(props) {
  var _props$type;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var width = (0,use_width_hook/* useWidth */.z)();
  var opts = {
    height: "380px",
    width: "100%",
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0
    }
  };

  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var configProp = _objectSpread({
    open: open,
    TransitionComponent: slide_transition/* default */.Z,
    onClose: handleClose,
    fullWidth: true,
    fullScreen: ["xs", "sm"].includes(width),
    maxWidth: "md"
  }, props);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/react.cloneElement(props.children, {
    onClick: handleClickOpen,
    id: "FormJoinRemax"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogCustom, configProp, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogHeader, configProp), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, props.src ? (0,emotion_react_browser_esm/* jsx */.tZ)(ModalVideo, {
    controls: true,
    autoPlay: true,
    playsInline: true,
    title: props.title
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("source", {
    src: props.src,
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "video/mp4"
  })) : (0,emotion_react_browser_esm/* jsx */.tZ)(YouTube_esm/* default */.Z, {
    videoId: props.url,
    opts: opts
  }))));
}

var DialogHeader = function DialogHeader(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
    css: stylesDialogHeader.root,
    fontSize: 12,
    align: "right"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-brand-grey-secondary",
    onClick: function onClick() {
      return props.onClose();
    }
  }, "Cerrar"));
};

var TitleForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1yc4ldu2"
} : 0)( true ? {
  name: "ktin61",
  styles: "color:var(--color-brand-grey-main);font-size:1.2rem;margin-bottom:10px"
} : 0);

var ModalVideo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("video",  true ? {
  target: "e1yc4ldu1"
} : 0)( true ? {
  name: "1vu7pnu",
  styles: "background-color:#000;border-radius:12px;display:block;max-height:70vh;width:100%"
} : 0);

var DialogCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1yc4ldu0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return {
    "& .MuiDialog-paper": {
      backgroundColor: "#EFEFF1",
      borderRadius: "20px"
    }
  };
},  true ? "" : 0);

var stylesDialogHeader = {
  root:  true ? {
    name: "uq8ggj",
    styles: "text-align:right;font-size:13px;color:var(--color-brand-grey-main);cursor:pointer"
  } : 0
};
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
;// CONCATENATED MODULE: ./shared/components-pages/unete/Motivation.tsx


function Motivation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function VideosThumbnail(props) {
  var src = props.src,
      title = props.title;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join.motivation");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(VideoModal, {
    src: src,
    title: title
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(VideoTrigger, {
    type: "button",
    "aria-label": title
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ThumbnailWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PreviewVideo, {
    muted: true,
    playsInline: true,
    preload: "metadata"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("source", {
    src: src,
    type: "video/mp4"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(PlayOverlay, {
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(PlayArrow/* default */.Z, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(VideoText, null, translation("seeVideo"))));
}

var videosItems = [{
  src: "/videos/marion-testimonio-v1.mp4",
  title: "Testimonio Marion"
}];

function Motivation() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("join.motivation");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationVideos, null, videosItems.map(function (item, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("article", {
      key: index
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(VideosThumbnail, item));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationDescription, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationTitle, null, translation("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationText, null, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationText, null, translation("info")), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.frequent_questions */.K.es.frequent_questions,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(MotivationButton, {
    disableRipple: true,
    component: "a"
  }, translation("faq"))))));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ewojgm911"
} : 0)( true ? {
  name: "qjg6le",
  styles: "background-color:var(--color-brand-cream-primary);padding:85px 0;@media screen and (max-width: 767px){padding:2rem 1rem;*{text-align:center;}}"
} : 0);

var MotivationContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm910"
} : 0)( true ? {
  name: "w27gg",
  styles: "display:flex;justify-content:space-around;@media screen and (max-width: 991px){flex-direction:column;}"
} : 0);

var MotivationDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ewojgm99"
} : 0)( true ? {
  name: "1v42hdb",
  styles: "max-width:600px;padding:0px 10px;align-self:center;@media screen and (max-width: 767px){max-width:600px;display:flex;flex-direction:column;align-items:center;justify-content:center;}"
} : 0);

var MotivationTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ewojgm98"
} : 0)( true ? {
  name: "y8z4qt",
  styles: "font-size:1.338rem;font-weight:700;text-align:left;text-transform:none;margin-bottom:24px;color:var(--color-brand-blue-main);@media screen and (max-width: 767px){text-align:center;}"
} : 0);

var MotivationText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ewojgm97"
} : 0)( true ? {
  name: "pgg5ef",
  styles: "font-size:0.938rem;font-weight:700;line-height:18px;color:#99999b;margin-bottom:20px"
} : 0);

var MotivationButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "ewojgm96"
} : 0)( true ? {
  name: "12szge9",
  styles: "margin-top:15px;border-radius:15px;height:40px;color:var(--color-brand-bg-secondary);@media screen and (max-width: 991px){display:block;margin:35px auto 0;}&>a{color:inherit;}&:focus-visible{outline:Highlight auto 1px;outline:-webkit-focus-ring-color auto 1px;}"
} : 0);

var MotivationVideos = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm95"
} : 0)( true ? {
  name: "2b83kt",
  styles: "&>:nth-child(1){margin-bottom:1rem;}@media screen and (max-width: 991px){display:flex;justify-content:space-evenly;}@media screen and (max-width: 480px){flex-direction:column;align-items:center;margin-bottom:1rem;}"
} : 0);

var VideoTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ewojgm94"
} : 0)( true ? {
  name: "1yfbmyg",
  styles: "appearance:none;background:transparent;border:0;cursor:pointer;display:block;padding:0"
} : 0);

var PreviewVideo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("video",  true ? {
  target: "ewojgm93"
} : 0)( true ? {
  name: "7t7iiq",
  styles: "width:100%;height:100%;display:block;object-fit:cover"
} : 0);

var ThumbnailWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewojgm92"
} : 0)( true ? {
  name: "1458isa",
  styles: "width:460px;aspect-ratio:16/9;border-radius:20px;background-position:center;background-size:cover;background-repeat:no-repeat;margin-bottom:15px;overflow:hidden;position:relative;@media screen and (max-width: 480px){width:100%;max-width:380px;margin:auto;}"
} : 0);

var PlayOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ewojgm91"
} : 0)( true ? {
  name: "qc34eg",
  styles: "align-items:center;background-color:var(--color-brand-red-main);border-radius:50%;color:var(--color-text-white);display:flex;height:62px;justify-content:center;left:50%;position:absolute;top:50%;transform:translate(-50%, -50%);width:62px;svg{font-size:42px;}"
} : 0);

var VideoText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ewojgm90"
} : 0)( true ? {
  name: "1hhfj0i",
  styles: "font-size:0.875rem;font-weight:500;text-align:center;color:var(--color-brand-blue-main);cursor:pointer"
} : 0);

/* harmony default export */ var unete_Motivation = (Motivation);

/***/ }),

/***/ 47070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66621);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44231);
/* harmony import */ var custom_hooks_use_statistics_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53685);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function Statistic() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("join.statistic");
  var translationStatsLabel = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("join.statistic.statsLabel");
  var translationWhyBeAgent = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("join.statistic.whyBeAgent");
  var statisticDataItems_ = [{
    title: "1973",
    description: translationStatsLabel("founded")
  }, {
    title: "544",
    description: translationStatsLabel("agents")
  }, {
    title: "39",
    description: translationStatsLabel("offices")
  }, {
    title: "24 ".concat(translationStatsLabel("thousand")),
    description: translationStatsLabel("properties")
  }, {
    title: "+145 ".concat(translationStatsLabel("thousand")),
    description: translationStatsLabel("globalAgents")
  }];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(statisticDataItems_),
      items = _useState[0],
      setItems = _useState[1];

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_5__/* .useWidth */ .z)();

  var _useStatistics = (0,custom_hooks_use_statistics_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      statsResponse = _useStatistics.data,
      isLoading = _useStatistics.isLoading;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (statsResponse !== null && statsResponse !== void 0 && statsResponse.data) {
      statisticDataItems_[1].title = statsResponse.data.agents_count.toString();
      statisticDataItems_[2].title = statsResponse.data.agencies_count.toString();
      setItems(statisticDataItems_);
    }
  }, [statsResponse]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticContainer, {
    className: "container"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticTitle, null, translation.rich("title", {
    red: function red(chunks) {
      return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticTitleRed, null, chunks);
    },
    light: function light(chunks) {
      return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticTitleLight, null, chunks);
    }
  }), !["xs", "sm"].includes(width) && // <JoinRemaxForm>
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticButton, {
    component: "a",
    href: "https://reclutamiento.remaxrd.com/#Formulario",
    target: "_blank",
    rel: "noopener noreferrer"
  }, translation("joinFamily")) // </JoinRemaxForm>
  ), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticSubContainer, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticSubtitle, null, translationWhyBeAgent("title")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticText, null, translationWhyBeAgent("benefits")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticText, null, translationWhyBeAgent("info"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticData, null, items.map(function (item, index) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticDataItem, {
      key: index
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticDataTitle, null, item.title), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticDataDescription, null, item.description));
  })), ["xs", "sm"].includes(width) && // <JoinRemaxForm>
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticButton, {
    component: "a",
    href: "https://reclutamiento.remaxrd.com/#Formulario",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      marginTop: 30
    }
  }, translation("joinFamily")) // </JoinRemaxForm>
  ), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StatisticBackground, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Image, {
    src: "/images/image-optimize/agent-remax-join-franchise.webp",
    alt: "Buscando agente inmobiliario remax RD"
  }))));
}

var sharedCss =  true ? {
  name: "6iu8ll",
  styles: "margin-left:6%;@media screen and (max-width: 767px){margin-left:0;}"
} : 0;

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e4l52ew15"
} : 0)( true ? {
  name: "2gbbu9",
  styles: "background-color:var(--color-brand-cream-primary);padding:110px 0 0;margin-bottom:-5px;@media screen and (max-width: 1299px){overflow:hidden;}@media screen and (max-width: 450px){padding:100px 0 0;}"
} : 0);

var StatisticContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e4l52ew14"
} : 0)( true ? {
  name: "11o5g2v",
  styles: "display:flex;justify-content:space-between;@media screen and (max-width: 1299px){position:relative;padding-bottom:140px;}@media screen and (max-width: 767px){padding-bottom:2rem;}"
} : 0);

var StatisticContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e4l52ew13"
} : 0)( true ? {
  name: "17wyc4c",
  styles: "width:calc(100% - 534px);@media screen and (max-width: 1299px){width:calc(100% - 234px);}@media screen and (max-width: 991px){width:100%;}"
} : 0);

var StatisticTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e4l52ew12"
} : 0)(sharedCss, " font-size:3.313rem;font-weight:500;text-align:left;max-width:505px;margin-left:60px;text-transform:none;margin-bottom:-10px;line-height:30px;color:var(--color-brand-blue-main);@media screen and (max-width: 767px){font-size:2.313rem;text-align:center;margin:0 auto;}" + ( true ? "" : 0));

var StatisticTitleRed = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e4l52ew11"
} : 0)( true ? {
  name: "1f9jpmq",
  styles: "font-size:2.188rem;font-weight:700;color:var(--color-brand-red-main);margin-top:10px;display:block;width:100%;text-align:center;@media screen and (max-width: 767px){font-size:1.688rem;text-align:center;margin-left:0;}"
} : 0);

var StatisticTitleLight = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e4l52ew10"
} : 0)( true ? {
  name: "h4mn4v",
  styles: "font-size:1.938rem;font-weight:300;display:block;width:100%;text-align:center;@media screen and (max-width: 767px){font-size:1.438rem;text-align:center;margin-left:0;font-weight:400;}"
} : 0);

var StatisticBackground = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e4l52ew9"
} : 0)( true ? {
  name: "dpf57l",
  styles: "max-width:634px;align-self:flex-end;@media screen and (max-width: 1299px){position:absolute;right:-15%;bottom:0;}@media screen and (max-width: 1200px){position:absolute;right:-30%;bottom:0;}@media screen and (max-width: 991px){display:none;}"
} : 0);

var Image = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("img",  true ? {
  target: "e4l52ew8"
} : 0)( true ? {
  name: "16d60fp",
  styles: "width:100%;border-style:none"
} : 0);

var StatisticButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "e4l52ew7"
} : 0)( true ? {
  name: "1wdcd0y",
  styles: "margin-left:auto;margin-right:auto;margin-top:15px;display:block;font-weight:700;text-decoration:none;border-radius:15px;@media screen and (max-width: 767px){margin-left:auto;margin-right:auto;display:block;}"
} : 0);

var StatisticSubtitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3",  true ? {
  target: "e4l52ew6"
} : 0)(sharedCss, " margin-top:94px;font-size:1.438rem;font-weight:700;margin-bottom:17px;color:var(--color-brand-blue-main);@media screen and (max-width: 450px){margin-top:50px;}" + ( true ? "" : 0));

var StatisticSubContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e4l52ew5"
} : 0)( true ? {
  name: "smpydf",
  styles: "width:90%;margin:0 auto;@media screen and (max-width: 767px){*{text-align:center;}}"
} : 0);

var StatisticText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "e4l52ew4"
} : 0)(sharedCss, " font-size:0.938rem;font-weight:500;color:#99999b;margin-bottom:21px;max-width:625px;" + ( true ? "" : 0));

var StatisticData = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e4l52ew3"
} : 0)( true ? {
  name: "1iv732h",
  styles: "margin-top:65px;display:flex;justify-content:space-between;max-width:750px;@media screen and (max-width: 767px){flex-wrap:wrap;justify-content:center;}@media screen and (max-width: 700px){flex-wrap:wrap;justify-content:space-around;}"
} : 0);

var StatisticDataItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e4l52ew2"
} : 0)( true ? {
  name: "pja3cn",
  styles: "max-width:113px;@media screen and (max-width: 767px){margin:15px;}@media screen and (max-width: 575px){max-width:140px;*{text-align:center;}}@media screen and (max-width: 450px){width:50%;margin:15px 0;padding:0px;}"
} : 0);

var StatisticDataTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e4l52ew1"
} : 0)( true ? {
  name: "s45387",
  styles: "font-size:1.678rem;font-weight:700;color:var(--color-brand-blue-secondary);margin-bottom:4px;display:block;white-space:nowrap;text-align:center;@media screen and (max-width: 700px){font-size:35px;}@media screen and (max-width: 575px){max-width:140px;font-size:26px;}@media screen and (max-width: 450px){text-align:left;}"
} : 0);

var StatisticDataDescription = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e4l52ew0"
} : 0)( true ? {
  name: "pdn3z9",
  styles: "font-size:0.865rem;font-weight:700;color:var(--color-brand-grey-quaternary);display:block;text-align:center;@media screen and (max-width: 450px){text-align:left;}"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (Statistic);

/***/ }),

/***/ 79001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5616);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);


var _templateObject;





var WsPhantomNav = function WsPhantomNav() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(WsPhantomNavContainer, null);
};

/* harmony default export */ __webpack_exports__["Z"] = (WsPhantomNav);
var WsPhantomNavContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  width: 100%;\n  height: 70px;\n"])));

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 97472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




var SliderTransition = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Transition(props, ref) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    direction: "up",
    ref: ref
  }, props));
});
/* harmony default export */ __webpack_exports__["Z"] = (SliderTransition);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 36492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52924);
/* harmony import */ var _useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67187);
'use client';



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__/* .parseQueryArgs */ ._v)(arg1, arg2, arg3);
  return (0,_useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useBaseQuery */ .r)(parsedOptions, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .QueryObserver */ .z);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ })

}]);